<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >Python项目执行</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="虚拟机"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="是否启用"
                            field="isEnabled"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.isEnabled"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="启用"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="禁用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="状态"
                            field="status"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="运行中"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入姓名或邮箱"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        :loading="toolbar.loading"
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            field="status"
                            title="状态-操作"
                            width="120"
                            :title-help="{ message: '空闲中点击按钮运行项目' }"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    icon="fa fa-play"
                                    size="small"
                                    @click="startProcess(row)"
                                    :disabled="getDisable(row)"
                                    :status="getStatus(row)"
                                    round
                                    >{{ row.Status }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="projectID"
                            title="项目ID"
                            width="140"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="projectName"
                            title="项目名称"
                            width="250"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                         <vxe-column
                            field="deployType"
                            title="运行方式"
                            width="100"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="NAME"
                            title="业务人员"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevelopUser"
                            title="开发人员"
                            width="120"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="邮箱"
                            width="190"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="PCName"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器人简称"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="priority"
                            title="优先级"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="创建时间"
                            width="140"
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, toRef } from "vue";
import { VXETable, VxeTableInstance, VxeTablePropTypes } from "vxe-table";

export default {
    name: "ProjectTakeList",
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                selectMac: "",
                status: "",
                searchKey: "",
                isEnabled: "1",
            },
        });
        return {
            tableData: null,
            tablePager,
            toolbar,
            pageHeight,
            timer: null,
            tableHeight: 0,
        };
    },
    methods: {
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        //查询
        findData() {
            this.toolbar.loading = true;
            let selPc = "",
                selEnable = "",
                selStatus = "",
                selKey = "";
            selPc = this.toolbar.formData.selectMac;
            selEnable = this.toolbar.formData.isEnabled;
            selStatus = this.toolbar.formData.status;
            selKey = this.toolbar.formData.searchKey;
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: ["0", selPc, selEnable, selStatus, selKey],
            };
            this.$api.jobManageAPI
                .getProjectTakeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.toolbar.loading = false;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                    this.toolbar.loading = false;
                })
                .finally(() => {
                    this.toolbar.loading = false;
                });
        },
        //启动一个流程
        async startProcess(row) {
            if (row.deployType == "本地") {
                await this.execLocalFile(
                    row.projectID,
                    row.projectName,
                    row.localAppPath,
                    row.localAppType,
                    row.localExeFile,
                    row.localExeParam
                );
            } else {
                const type = await VXETable.modal.confirm(
                    "您确定要运行该项目吗?"
                );
                if (type === "confirm") {
                    const params = {
                        uid: this.$store.state.userID,
                        email: this.$store.state.email,
                        actionType: "1",
                        actionKey: [row.id, this.$store.state.userName],
                    };
                    this.$api.jobManageAPI
                        .startProcessPython(Qs.stringify(params))
                        .then((res) => {
                            if (res.data.Success == false) {
                                VXETable.modal.message({
                                    content: res.data.Message,
                                    status: "error",
                                });
                                return;
                            }
                            // console.log(res.data.Data);
                            this.findData();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        },
        async execLocalFile(
            ProcessID,
            ProcessName,
            localAppPath,
            localAppType,
            localExeFile,
            localExeParam
        ) {
            const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
            if (type === "confirm") {
                let safeProtocolName = "coe" + ProcessID;
                const params = localExeParam;
                if (!ProcessID?.trim()) {
                    VXETable.modal.message({
                        content: "请输入协议名称！",
                        status: "error",
                    });
                    return;
                }
                const link =
                    localExeParam != ""
                        ? `${safeProtocolName}://${params || ""}`
                        : `${safeProtocolName}://`;
                const a = document.createElement("a");
                a.href = link;
                a.click();
                this.addJobsLocal(
                    ProcessID,
                    ProcessName,
                    localAppPath,
                    localAppType,
                    localExeFile,
                    localExeParam
                );
            }
        },
        addJobsLocal(
            processID,
            processName,
            localAppPath,
            localAppType,
            localExeFile,
            localExeParam
        ) {
            const params = {
                ProcessID: processID,
                ProcessName: processName,
                CreatorUserId: this.$store.state.email,
                localAppPath: localAppPath,
                localAppType: localAppType,
                localExeFile: localExeFile,
                localExeParam: localExeParam,
            };
            this.$api.dEmpAPI
                .addJobLocal(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAsset() {
            this.$router.push({ name: "assetList" });
        },
        getStatus(row) {
            if (row.Status === "空闲中") {
                return "success";
            }
        },
        getDisable(row) {
            return row.Status !== "空闲中";
        },
        handlePageChange() {
            this.findData();
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
            this.toolbar.formData.isEnabled = "1";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        setTimer() {
            this.timer = setInterval(() => {
                window.setTimeout(this.findData, 0);
            }, 1000 * 15);
        },
        clearTimer() {
            window.clearInterval(this.timer);
            this.timer = null;
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        this.setTimer();
        window.addEventListener("keydown", this.keydown);
    },
    beforeUnmount() {
        window.removeEventListener("keydown", this.keydown, false);
        this.clearTimer();
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
